<script>
import { currency } from '@/stores/basket'
import LazyPictureTag from '@/components/LazyPictureTag'
import {
  formatPrice,
  roundPrice,
  vatPrice,
} from '../../../../../../Greativ/helper/price'
import { computed } from 'vue'

export default {
  components: {
    LazyPictureTag,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const totalPrice = computed(() => {
      if(typeof props.product.customPrice !== 'undefined'){
        return props.product.customPrice
      }

      if (props.product.extraDiscount !== null) {
        return (
          roundPrice(vatPrice(props.product.extraDiscount, props.product.vat) * props.product.amount)
        )
      }

      if (props.product.discountPrice) {
        return roundPrice(
          vatPrice(props.product.discountPrice, props.product.vat) *
            props.product.amount
        )
      }

      return (
        roundPrice(vatPrice(props.product.price, props.product.vat)) *
        props.product.amount
      )
    })

    return {
      currency,
      formatPrice,
      totalPrice,
    }
  },
}
</script>

<template>
  <div class="flex items-center">
    <div class="w-52 flex-shrink-0 py-3 mr-10">
      <div class="relative pb-100% image">
        <LazyPictureTag
          fallbackImage="ui/template/rallyestonia/images/no-image-placeholder-with-space.svg"
          :fallbackImageWidth="140"
          :fallbackImageHeight="140"
          :fallbackImageAlt="product.productName"
          loadingImage="ui/template/rallyestonia/images/no-image-placeholder-with-space.svg"
          class="
            absolute
            inset-0
            object-contain
            w-full
            h-full
            !max-w-100% !max-h-100%
            m-auto
          "
          :sizes="
            product.image
              ? [
                  {
                    mediaRule: 300,
                    url: product.image,
                    config: {
                      w: 160,
                      h: 160,
                      fit: 'max',
                    },
                  },
                ]
              : []
          "
        />
      </div>
    </div>
    <div class="text-7 font-black">
      <div>{{ product.productName }}</div>
      <div v-if="product.parameters.length">
        <div
          class="font-normal"
          v-for="(parameter, parameterIndex) in product.parameters"
          :key="`pp${parameterIndex}`"
        >
          {{ parameter.name }}: {{ parameter.value }}
        </div>
      </div>
      <div v-if="product.barCode !== 'RALLY_PASS'">x{{ product.amount }}</div>
      <div class="text-red text-7 font-black">
        {{ formatPrice(totalPrice) }}
        {{ currency }}
      </div>
    </div>
  </div>
</template>
